import { render, staticRenderFns } from "./CartPayWhatYouCan.vue?vue&type=template&id=f96ab8ca&scoped=true"
import script from "./CartPayWhatYouCan.vue?vue&type=script&lang=ts"
export * from "./CartPayWhatYouCan.vue?vue&type=script&lang=ts"
import style0 from "./CartPayWhatYouCan.vue?vue&type=style&index=0&id=f96ab8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96ab8ca",
  null
  
)

export default component.exports